<template>
  <div id="qualification-container">
    <Title title="Qualifications"></Title>

    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{
      snackbarText
    }}</v-snackbar>

    <v-container>
      <v-row>
        <v-col sm="3">
          <span
            style="cursor: pointer"
            @click="onFilterQualifications('registered')"
          >
            <InsightCard :title="'Registered'" :count="totalRegistered" />
          </span>
        </v-col>
        <v-col sm="3">
          <span
            style="cursor: pointer"
            @click="onFilterQualifications('active')"
          >
            <InsightCard :title="'Active'" :count="totalActive" />
          </span>
        </v-col>
        <v-col sm="3">
          <span
            style="cursor: pointer"
            @click="onFilterQualifications('inactive')"
          >
            <InsightCard :title="'Inactive'" :count="totalInactive" />
          </span>
        </v-col>
      </v-row>

      <v-row>
        <v-col lg="12" md="12" sm="12">
          <QualificationTable
            :headers="qualificationHeaders"
            :items="qualifications"
            :title="'qualification.qualification'"
            :modalText="'Qualification'"
            :apiRoute="'qualifications'"
            :isLoading="isQualificationsLoading"
            @optionAdded="onOptionAdded"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import QualificationTable from "../components/QualificationTable";
import InsightCard from "../components/InsightCard";
import Title from "../components/Title";

export default {
  mounted: function () {
    this.getQualifications();

    // display snackbar after add qualification
    if (this.$route.params.message) {
      this.snackbarText = this.$route.params.message;
      this.snackbar = true;
    }
  },
  components: {
    QualificationTable,
    InsightCard,
    Title,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      qualifications: [],
      filteredQualifications: [],
      endorsedQualifications: [],
      isQualificationsLoading: true,
      headers: [
        { text: this.$t("qualification.code"), value: "code" },

        { text: this.$t("qualification.name"), value: "name" },
        { text: "QAN", value: "qan" },
        { text: this.$t("qualification.level"), value: "level" },
        { text: this.$t("qualification.credits"), value: "credits" },
        { text: "Status", value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ],
      endorsedHeaders: [
        { text: "Code", value: "code" },
        { text: "Name", value: "name" },
        { text: "Centre", value: "centreName" },
        { text: this.$t("qualification.level"), value: "level" },
        { text: "Status", value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    qualificationHeaders: function () {
      if (this.$store.state.role == "centre") {
        const headers = [];

        for (let i = 0; i < this.headers.length; i++) {
          if (this.headers[i].value.toLowerCase() != "actions") {
            headers.push(this.headers[i]);
          }
        }
        return headers;
      }

      return this.headers;
    },
    modifiedEndorsedHeaders: function () {
      const headers = [];

      if (this.$store.state.role == "centre") {
        for (let i = 0; i < this.endorsedHeaders.length; i++) {
          if (this.endorsedHeaders[i].value.toLowerCase() != "centrename") {
            headers.push(this.endorsedHeaders[i]);
          }
        }

        return headers;
      } else if (this.$store.state.role == "ao") {
        for (let i = 0; i < this.endorsedHeaders.length; i++) {
          if (this.endorsedHeaders[i].value.toLowerCase() != "actions") {
            headers.push(this.endorsedHeaders[i]);
          }
        }

        console.log(headers);

        return headers;
      }

      return this.endorsedHeaders;
    },
    endorsedCourseTitle: function () {
      if (this.$store.state.role == "centre") {
        return "Endorsed Course";
      }

      return "Centre Endorsed Courses";
    },
    totalRegistered: function () {
      return this.qualifications.length;
    },
    totalActive: function () {
      const totalActive = this.qualifications.filter((qualification) => {
        return qualification.status.toLowerCase() == "active";
      });

      return totalActive.length;
    },
    totalInactive: function () {
      const totalInactive = this.qualifications.filter((qualification) => {
        return qualification.status.toLowerCase() == "inactive";
      });

      return totalInactive.length;
    },
  },
  watch: {
    isQualificationsLoading: function (newValue) {
      this.isQualificationsLoading = newValue;
    },
  },
  methods: {
    getQualifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.filteredQualifications = data.qualifications;

          for (let i = 0; i < data.qualifications.length; i++) {
            if (data.qualifications[i].type.toLowerCase() == "endorsed") {
              this.endorsedQualifications.push(data.qualifications[i]);
            } else {
              this.qualifications.push(data.qualifications[i]);
            }
          }

          this.isQualificationsLoading = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onOptionAdded: function (data) {
      this.getQualifications();

      this.snackbarText = data.message;
      this.snackbar = true;
    },
    onFilterQualifications: function (type) {
      if (type == "registered") {
        this.filteredQualifications = this.qualifications;
        return;
      }

      this.filteredQualifications = this.qualifications.filter(
        (qualification) => {
          return qualification.status.toLowerCase() == type;
        }
      );
    },
  },
};
</script>

<style scoped>
h3 {
  display: inline-block;
}

#add-unit-btn {
  float: right;
  background-color: #7764e4;
}

#qualification-container {
  min-height: 100vh;
}
</style>